export default "__VITE_ASSET__4U4OeISn__"